import(/* webpackMode: "eager" */ "/app/apps/web/src/app/(marketing)/industries/fleet-management/page.tsx");
